import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './deals-banner-small-logos.component.scss';
import Slider from '../slider/slider.component';
var DealsBannerSmallLogos = /** @class */ (function (_super) {
    tslib_1.__extends(DealsBannerSmallLogos, _super);
    function DealsBannerSmallLogos(element) {
        return _super.call(this, element) || this;
    }
    DealsBannerSmallLogos.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev
            },
            autoplay: {
                delay: 7000
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    DealsBannerSmallLogos.prototype.bindEvents = function () { };
    return DealsBannerSmallLogos;
}(Base));
export { DealsBannerSmallLogos };



//////////////////
// WEBPACK FOOTER
// ./components/deals-banner-small-logos/deals-banner-small-logos.component.ts
// module id = 247
// module chunks = 0